import { END_POINT_SEVER } from "../constants";
import axios from "axios";
import { SuccessSwal, WarningNetworkFailure } from "../helpers/alertseet";

export const get_all_statistic_by_date = async (branchId, token) => {
  try {
    const url = `${END_POINT_SEVER}/api/report/getAllStatisticByDate/${branchId}`;
    const res = await axios.get(url, {
      headers: { authorization: `Bearer ${token}` },
    });
    return res.data;
  } catch (error) {
    if (error.message === "Network Error") {
      WarningNetworkFailure();
    }
    console.error("error", error);
    return { error: true };
  }
};

export const get_all_statistic = async (branchId, token) => {
  try {
    const url = `${END_POINT_SEVER}/api/report/getAllStatistic/${branchId}`;
    const res = await axios.get(url, {
      headers: { authorization: `Bearer ${token}` },
    });
    return res.data;
  } catch (error) {
    if (error.message === "Network Error") {
      WarningNetworkFailure();
    }
    console.error("error", error);
    return { error: true };
  }
};

export const get_balance_by_time = async (findby, token) => {
  try {
    const url = `${END_POINT_SEVER}/api/balance/getBalanceByTime${findby}`;
    const res = await axios.get(url, {
      headers: { authorization: `Bearer ${token}` },
    });
    return res.data;
  } catch (error) {
    if (error.message === "Network Error") {
      WarningNetworkFailure();
    }
    console.error("error", error);
    return { error: true };
  }
};

export const get_member_by_time = async (findby, token) => {
  try {
    const url = `${END_POINT_SEVER}/api/member/getMemberByTime${findby}`;
    const res = await axios.get(url, {
      headers: { authorization: `Bearer ${token}` },
    });
    return res.data;
  } catch (error) {
    if (error.message === "Network Error") {
      WarningNetworkFailure();
    }
    console.error("error", error);
    return { error: true };
  }
};

export const get_loan_by_time = async (findby, token) => {
  try {
    const url = `${END_POINT_SEVER}/api/loan/getLoanByTime${findby}`;
    const res = await axios.get(url, {
      headers: { authorization: `Bearer ${token}` },
    });
    return res.data;
  } catch (error) {
    if (error.message === "Network Error") {
      WarningNetworkFailure();
    }
    console.error("error", error);
    return { error: true };
  }
};

export const get_profit_of_interest_rate = async (findby, token) => {
  try {
    const url = `${END_POINT_SEVER}/api/loan/getProfitOfInterestRate${findby}`;
    const res = await axios.get(url, {
      headers: { authorization: `Bearer ${token}` },
    });
    return res.data;
  } catch (error) {
    if (error.message === "Network Error") {
      WarningNetworkFailure();
    }
    console.error("error", error);
    return { error: true };
  }
};



// for new report

export const getReportAmount = async (branchId,filter,token) =>{
  try {
    if(!branchId) return 
    const config = {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${token}`,
      },
      params : {
        year : filter
      }
    };
    const url = `${END_POINT_SEVER}/api/report/report-amount/${branchId}`;
    const res = await axios.get(url, config);
    return res.data;
  } catch (error) {
    if (error.message === "Network Error") {
      WarningNetworkFailure();
    }
    console.error("error", error);
    return { error: true };
  }
}

export const getReportMember = async (branchId,filter,token) =>{
  try{
    const config = {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${token}`,
      },
      params : {
        year : filter
      }
    };
    const url = `${END_POINT_SEVER}/api/report/report-members/${branchId}`;
    const res = await axios.get(url, config);
    return res.data;
  }catch(error){
    if (error.message === "Network Error") {
      WarningNetworkFailure();
    }
    console.error("error", error);
    return { error: true };
  }
}

export const getStatisticReport = async (branchId,filter,token) =>{
  try{
    const config = {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${token}`,
      },
      params : {
        year : filter
      }
    };
    const url = `${END_POINT_SEVER}/api/report/report-statistic/${branchId}`;
    const res = await axios.get(url, config);
    return res.data;
  }catch(error){
    if (error.message === "Network Error") {
      WarningNetworkFailure();
    }
    console.error("error", error);
    return { error: true };
  }
}
